import * as R from 'ramda'
import moment from 'moment'
import { getDeviceInfo } from 'helpers/useragent'
import { getSuperProps, getDistinctId } from 'tracking/mixPanel'
import { DATE_FORMAT } from 'constants/dateFormats'
import { callPlanet } from '.'

const formatDate = string => date => moment(date).format(string)
const formatDates = string => R.map(formatDate(string))

const getMPProps = R.compose(
  encodeURIComponent,
  btoa,
  JSON.stringify,
  getSuperProps
)

// export type CheckoutApiResponse = {
//   +checkoutDisabled: boolean,
//   +dataToPost: {},
//   +redirectTo: string,
//   +requestId: string,
//   +secondsBeforeRedirection: number,
//   +success: boolean
// }

// export type CheckoutApiRequest = {
//   +status: number,
//   +response: CheckoutApiResponse
// }

export const withoutPackagesCheckoutCall = (
  marketId,
  cultureCode,
  countryCode,
  version,
  saleKey,
  key,
  price,
  deviceType,
  productTitle,
  shouldDoubleThePrice = false
) => {
  const { webview } = getDeviceInfo()

  const uri = `Checkout/${countryCode}/${cultureCode}/${deviceType}/${saleKey}/${key}/${version}`

  const body = {
    distinctId: getDistinctId(),
    marketId,
    mpProperties: getMPProps(),
    navigationType: (webview)
      ? 'webview'
      : 'navigator',
    productLabel: productTitle,
    returnUri: window.location.href,
    shouldDoubleThePrice,
    vpDisplayedPrice: price
  }
  return callPlanet(uri, body)
}

export const checkoutCall = (
  marketId,
  cultureCode,
  countryCode,
  packageLabel,
  version,
  saleKey,
  key,
  packageKey,
  selectedPackageElement,
  participants,
  adultsBirthdates,
  childrenBirthdates,
  babiesBirthdates,
  deviceType,
  productTitle,
  benefits,
  shouldDoubleThePrice = false
) => {
  const { webview } = getDeviceInfo()

  const uri = `Checkout/${countryCode}/${cultureCode}/${deviceType}/${saleKey}/${key}/${packageKey}/${selectedPackageElement.key}/${version}`

  const body = {
    checkinDate: selectedPackageElement.checkin,
    cultureCode,
    dayCount: selectedPackageElement.days,
    departureCity: selectedPackageElement.departureCity,
    distinctId: getDistinctId(),
    eventKey: saleKey,
    marketId,
    mpProperties: getMPProps(),
    navigationType: (webview)
      ? 'webview'
      : 'navigator',
    nightCount: selectedPackageElement.nights,
    packageKey,
    packageLabel,
    participantsDetails: {
      adultBirthDates: formatDates(DATE_FORMAT)(adultsBirthdates ?? []),
      adultCount: participants?.adults?.number ?? benefits ?? 0,
      babyBirthDates: formatDates(DATE_FORMAT)(babiesBirthdates ?? []),
      babyCount: participants?.babies?.number ?? 0,
      childBirthDates: formatDates(DATE_FORMAT)(childrenBirthdates ?? []),
      childCount: participants?.children?.number ?? 0
    },
    productLabel: productTitle,
    returnUri: window.location.href,
    shouldDoubleThePrice,
    vpDisplayedPrice: selectedPackageElement.price
  }

  return callPlanet(uri, body)
}

export const checkoutCancelCall = (
  packageKey,
  requestId
) => callPlanet(
  'Checkout/Cancel',
  { packageKey, requestId }
)

export const checkoutRedirectionCall = (
  cultureCode,
  marketId,
  packageKey,
  requestId,
  saleKey
) => callPlanet(
  'Checkout/Redirect',
  { cultureCode, eventKey: saleKey, marketId, packageKey, requestId }
)
